module.exports = __webpack_public_path__ + "static/media/3-square-unavailable.aafe5429.svg";